var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sw--position-relative",
      on: { mouseleave: _vm.closeTools }
    },
    [
      _vm.toolsOpen
        ? _c(
            "div",
            {
              staticClass:
                "sw--position-absolute\n                sw--padding-top-5\n                sw--padding-hor-3\n                z-index-10",
              class: _vm.containerClass
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "sw--border-grey-1 sw-dms--bg-white sw--border-radius-3 sw--box-shadow-1 sw--translate-z-0"
                },
                [
                  _c(
                    "nav",
                    { staticClass: "sw--padding-vert-1 sw--font-size-12" },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "sw--list-style-none sw--margin-left-0"
                        },
                        [
                          _vm.showUpdateModel
                            ? _c("li", [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center",
                                    attrs: {
                                      "event-action": "Tools",
                                      "event-label": "Update"
                                    },
                                    on: { click: _vm.updateModel }
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "icon-upload sw--font-size-22 sw-dms--color-grey-46"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "sw--display-block\n                                 sw-dms--text-dark\n                                 sw--margin-left-2\n                                 sw--font-size-14\n                                 sw--white-space-no-wrap"
                                      },
                                      [_vm._v("Update")]
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "sw-user-account-widget__link\n                            sw--padding-vert-2\n                            sw--padding-hor-5\n                            sw-grid-flex\n                            sw-grid-flex--align-center",
                                attrs: {
                                  "data-sw-noty": "",
                                  "data-sw-noty-id": _vm.modelRenameNotyId,
                                  "data-sw-noty-href": _vm.modelRenameUrl,
                                  "data-sw-noty-timeout": "false",
                                  "data-sw-noty-type": "content",
                                  "data-sw-noty-layout": "swCenterContent",
                                  "data-sw-noty-modal": "true",
                                  "data-sw-noty-close-with": '["backdrop"]',
                                  "event-action": "Tools",
                                  "event-label": "Rename"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "icon-pencil sw--font-size-22 sw-dms--color-grey-46"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sw--display-block\n                                 sw-dms--text-dark\n                                 sw--margin-left-2\n                                 sw--font-size-14\n                                 sw--white-space-no-wrap"
                                  },
                                  [_vm._v("Rename")]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "sw-user-account-widget__link sw--padding-vert-2 sw--padding-hor-5 sw-grid-flex sw-grid-flex--align-center",
                                attrs: {
                                  href: _vm.downloadUrl,
                                  "event-action": "Tools",
                                  "event-label": "Download"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "icon-download-2 sw--font-size-22 sw-dms--color-grey-46"
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sw--display-block\n                                 sw-dms--text-dark\n                                 sw--margin-left-2\n                                 sw--font-size-14\n                                 sw--white-space-no-wrap"
                                  },
                                  [_vm._v("Download")]
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sw--cursor-pointer", on: { click: _vm.openTools } },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }